// 个人中心

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
